import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { UserRound } from "lucide-react";

export function ProfileDialog({ open, onOpenChange }) {
  const { user, setUser } = useAuth();
  const [name, setName] = useState("");
  const [emailContact, setEmailContact] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (open) { setName(user?.name || ""); setEmailContact(user?.email_contact || ""); } }, [open, user]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.put("/auth/profil", { name, email_contact: emailContact });
      setUser((u) => ({ ...u, ...data }));
      toast.success("Profil mis à jour");
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="profile-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-dd-blue"><UserRound size={18} /> Mon profil</DialogTitle>
          <DialogDescription>Identifiant de connexion : <strong>{user?.email}</strong> (non modifiable).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="profil-name">Nom affiché</Label>
            <Input id="profil-name" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} className="mt-1 h-11" data-testid="profil-name" />
          </div>
          <div>
            <Label htmlFor="profil-email-contact">E-mail de contact (réponses des locataires)</Label>
            <Input id="profil-email-contact" type="email" value={emailContact} onChange={(e) => setEmailContact(e.target.value)} placeholder={user?.email} className="mt-1 h-11" data-testid="profil-email-contact" />
            <p className="text-xs text-dd-warm mt-1">Utilisé comme adresse de réponse dans les e-mails de constats que vous envoyez. Vide = votre identifiant.</p>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-dd-blue hover:bg-dd-night text-white" data-testid="profil-submit">
            {loading ? "Enregistrement…" : "Enregistrer"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
